import { Route, Routes, useParams } from "react-router-dom";
import Page from "./page";
import Mainpage from "./mainpage";

function PageWrapper(): React.ReactElement {
  const params = useParams<{ filename: string }>();
  return <Page filename={params.filename!} />;
}

export default function Blog() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Mainpage />} />
        <Route path=":filename" element={<PageWrapper />} />
      </Routes>
    </>
  );
}
